import DataTile from "./DataTile";
import {fetchVectorsAction} from "../../../actions";
import React from "react";
import {
     bbGetArrayOfBreachAttackIdsFromVectors,

    bbTranslateRiskToColor,
} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import RiskRibbon from "../../risk/RiskRibbon";
import BBIconShieldImportant from "../../../assets/bbCustomIcons/BBIconShieldImportant";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView, metaCampaigns} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    // "vectors": {
    //         "p0d46f1b-df9f-4704-beb9-f6589edff823": {
    //             "Id": "p0d46f1b-df9f-4704-beb9-f6589edff823",
            //     ...
            //     "Attack Totals": {
            //         "attacks": 1,
            //             "attacks_defeated": 0,
            //             "lastAttack": "2020-10-15 16:54:08",
            //             "pages": 1,
            //             "page_size": 10,
            //             "past_breaches": [
            //             "92ede098-0164-44db-9637-9c69a96fed5e"
            //         ],
            //             "current_breaches": []
            //     },
    //     }

    //current breaches is an array that holds the ids of the attacks that should be shown.

    const valueFunction = (stateData) => {
        if(stateData && stateData[customerIdToUse]) {
            try {

                let activeBreaches = [];

                if (stateData[customerIdToUse].vectors) {
                    //go through the vectors
                    const vectors = stateData[customerIdToUse].vectors
                    const current_breaches = bbGetArrayOfBreachAttackIdsFromVectors(vectors, false)
                    if (current_breaches) {
                        Array.prototype.push.apply(activeBreaches, current_breaches);
                    }
                }



                if (metaCampaigns) {
                    //go through the campaign meta
                    // "customerId": {
                    //     "total_phishing_attacks": 1,
                    //         "past_breaches": [],
                    //         "current_breaches": [
                    //         "e8184918-87b0-450f-a141-b1e3176051d4"
                    //     ]
                    // },
                    //go through each vector, and compile an array of all active_breaches
                    if (metaCampaigns.hasOwnProperty(customerIdToUse)) {
                        const {
                            current_breaches : currentCampaignBreaches = []
                        } = metaCampaigns[customerIdToUse]

                        Array.prototype.push.apply(activeBreaches, currentCampaignBreaches);

                    }
                }

                // console.log("Found the following activeBreaches in the vectors and campaigns for this customer", activeBreaches, stateData, metaCampaigns);

                return activeBreaches.length;

            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    const translateValueToRisk = (value) => {
        if (typeof value !== "number") {
            return null
        } else if (value <= 0) {
            return 0
        } else if (value <= 0) {
            return 1
        } else if (value <= 0) {
            return 2
        } else if (value <= 0) {
            return 3
        } else {
            return 4
        }
    }

    const colorFunction = (stateData) => {
        const num = valueFunction(stateData);
        return bbTranslateRiskToColor(translateValueToRisk(num));
    }

    const riskRibbon = (stateData) => {
        const num = translateValueToRisk(valueFunction(stateData));
        return num
            ? <RiskRibbon ratingBy5={num} />
            : null;
    }


    return (
        <DataTile
            colorBgFunction={colorFunction}
            subTitle="Active Breaches"
            tipText={`Number of ongoing breaches from all perimeter and social engineering vectors.  If this number is more than 0, you are being breached right now by CIRT. Your team should work to immediately find and stop the breach."`}
            icon={<BBIconShieldImportant style={{fontSize: "70px"}}/>}
            stateName="customer"
            stateElement="customers"
            useDeepDataStore
            // dontFetch
            deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            stateLoaderName="loadingVectors"
            stateLoaderError="loadingVectorsError"
            stateFetchAction={fetchVectorsAction({
                customerId: customerIdToUse
            })}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            requiresModule={"perimeter"}
        />
    )

}

export default Tile;